import WoundTherapyGuide from './WoundTherapyGuide';

export default WoundTherapyGuide;
